/* Single-article share row — Figma 2034:5104.

   The design's share cluster includes a copy-link target, which unlike the
   other five is an action on the current page rather than a navigation. It is
   rendered as a <button>, so this component wires the click.

   Scoped to `this` rather than the document so multiple share blocks (or the
   theme editor re-rendering the section) each keep their own listener. */

if (!customElements.get('article-share')) {
  customElements.define(
    'article-share',
    class ArticleShare extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-share-url]');
        this._onCopy = this.onCopy.bind(this);
      }

      connectedCallback() {
        if (this.button) this.button.addEventListener('click', this._onCopy);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this._onCopy);
      }

      onCopy() {
        const url = this.button.dataset.shareUrl;
        if (!url || !navigator.clipboard) return;

        navigator.clipboard.writeText(url).then(() => {
          /* No label to swap — the button is icon-only — so the confirmation is
             a class the stylesheet can act on, plus a live-region announcement
             for anyone not seeing the visual change. */
          this.button.classList.add('is-copied');
          this.setAttribute('aria-live', 'polite');

          setTimeout(() => {
            this.button.classList.remove('is-copied');
          }, 2000);
        });
      }
    }
  );
}
